import { z } from "zod";

export const browserFingerprintSchema = z.object({
  userAgent: z.string(),
  language: z.string(),
  languages: z.array(z.string()),
  platform: z.string(),
  cookieEnabled: z.boolean(),
  doNotTrack: z.string().nullable(),
  hardwareConcurrency: z.number(),
  maxTouchPoints: z.number(),
  vendor: z.string(),
  vendorSub: z.string(),
  productSub: z.string(),
  oscpu: z.string().optional(),
  availableFonts: z.array(z.string()),
});

export const screenFingerprintSchema = z.object({
  width: z.number(),
  height: z.number(),
  availWidth: z.number(),
  availHeight: z.number(),
  colorDepth: z.number(),
  pixelDepth: z.number(),
  orientation: z
    .object({
      angle: z.number(),
      type: z.string(),
    })
    .optional(),
});

export const timezoneFingerprintSchema = z.object({
  timezone: z.string(),
  timezoneOffset: z.number(),
  locale: z.string(),
});

export const canvasFingerprintSchema = z.object({
  canvasFingerprint: z.string(),
  webglFingerprint: z.string().optional(),
});

export const audioFingerprintSchema = z.object({
  audioFingerprint: z.string().optional(),
});

export const deviceInfoSchema = z.object({
  deviceMemory: z.number().optional(),
  connectionType: z.string().optional(),
  connectionEffectiveType: z.string().optional(),
  connectionDownlink: z.number().optional(),
  connectionRtt: z.number().optional(),
});

export const fingerprintDataSchema = z.object({
  browser: browserFingerprintSchema,
  screen: screenFingerprintSchema,
  timezone: timezoneFingerprintSchema,
  canvas: canvasFingerprintSchema,
  audio: audioFingerprintSchema,
  device: deviceInfoSchema,
  hash: z.string(), // SHA-256 hash of all fingerprint data
  collectedAt: z.date(),
});

export type BrowserFingerprint = z.infer<typeof browserFingerprintSchema>;
export type ScreenFingerprint = z.infer<typeof screenFingerprintSchema>;
export type TimezoneFingerprint = z.infer<typeof timezoneFingerprintSchema>;
export type CanvasFingerprint = z.infer<typeof canvasFingerprintSchema>;
export type AudioFingerprint = z.infer<typeof audioFingerprintSchema>;
export type DeviceInfo = z.infer<typeof deviceInfoSchema>;
export type FingerprintData = z.infer<typeof fingerprintDataSchema>;

// Fingerprint collection status enum
export enum FingerprintCollectionStatus {
  NOT_STARTED = "not_started",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  FAILED = "failed",
}

export const fingerprintCollectionResultSchema = z.object({
  status: z.nativeEnum(FingerprintCollectionStatus),
  data: fingerprintDataSchema.optional(),
  error: z.string().optional(),
  collectionTimeMs: z.number(),
});

export type FingerprintCollectionResult = z.infer<
  typeof fingerprintCollectionResultSchema
>;
